import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getDocumentFieldTypes, getDocumentTypes, getSystem } from 'store/system/selectors';

const selectDocumentExtractionMapping = createSelector(
  getSystem,
  ({ documentExtractionMapping }) => documentExtractionMapping,
);

export const selectLoanFields = createSelector(
  selectDocumentExtractionMapping,
  documentExtractionMapping => documentExtractionMapping?.loanFields,
);

export const selectEnumTypes = createSelector(
  selectDocumentExtractionMapping,
  documentExtractionMapping => documentExtractionMapping?.enumTypes,
);

export const selectDocExtractionFieldsByDocTypeId = memoizeOne(documentTypeId =>
  createSelector(
    [selectDocumentExtractionMapping, getDocumentFieldTypes],
    (documentExtractionMapping, documentFieldTypes) =>
      documentExtractionMapping?.docExtractionFields?.[documentTypeId]
        ?.map(props => ({
          ...props,
          type: documentFieldTypes?.[props.documentFieldTypeId]?.typeDefinition.type || '',
        }))
        .sort((a, b) => a.orderNumber - b.orderNumber),
  ),
);

export const selectDocumentExtractionMappingList = createSelector(
  selectDocumentExtractionMapping,
  documentExtractionMapping => documentExtractionMapping?.docExtractionMapping,
);

const selectDocumentExtractionMappingValues = createSelector(
  selectDocumentExtractionMappingList,
  Object.values,
);

export const selectDocumentExtractionMappingListWithDocTypeName = createSelector(
  getDocumentTypes,
  selectDocumentExtractionMappingValues,
  (documentTypes, documentExtractionMappingList) => {
    const mappingWithDocumentTypeNames = documentExtractionMappingList?.map(mappingItem => ({
      ...mappingItem,
      documentTypeName: documentTypes?.[mappingItem.documentTypeId]?.documentTypeName,
    }));

    return _.orderBy(mappingWithDocumentTypeNames, ({ documentTypeName }) =>
      documentTypeName?.toLowerCase(),
    );
  },
);
